export default "__VITE_ASSET__d1a09266__"